import { bareAdAccountId } from "@/lib/ads/adAccounts";

export interface AdsSyncPin {
  workspaceId: string;
  adAccountId: string;
  adAccountName?: string | null;
}

export function sameAdAccount(a: unknown, b: unknown): boolean {
  const left = bareAdAccountId(a);
  return left !== "" && left === bareAdAccountId(b);
}

export function isPinnedAccountQuery(queryKey: readonly unknown[], pin: AdsSyncPin): boolean {
  return queryKey[2] === pin.workspaceId && sameAdAccount(queryKey[3], pin.adAccountId);
}

export function syncPinFor(
  workspaceId: string | null | undefined,
  account: { ad_account_id?: string | null; ad_account_name?: string | null } | null | undefined,
): AdsSyncPin | null {
  if (!workspaceId || !account?.ad_account_id) return null;
  return { workspaceId, adAccountId: String(account.ad_account_id), adAccountName: account.ad_account_name ?? null };
}

export function isSyncingAccount(
  sync: { isPending: boolean; variables?: AdsSyncPin },
  pin: AdsSyncPin | null,
): boolean {
  if (!sync.isPending || !pin || !sync.variables) return false;
  return sync.variables.workspaceId === pin.workspaceId && sameAdAccount(sync.variables.adAccountId, pin.adAccountId);
}
